//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { GetAllLogosResponse } from './models/GetAllLogosResponse';
import type { GetAllSectionsResponse } from './models/GetAllSectionsResponse';
import type { SearchBannersRequest } from './models/SearchBannersRequest';
import type { SearchBannersResponse } from './models/SearchBannersResponse';
import type { Signature } from './models/Signature';
import type { SignatureBodyResponse } from './models/SignatureBodyResponse';
import type { Template } from './models/Template';
import { Utilities } from './Utilities';

export class SignaturesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getSignature: (): string => {
            let clientRequestUrl = '/api/v3/signatures';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        saveSignature: (): string => {
            let clientRequestUrl = '/api/v3/signatures';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSignatureBodyForCurrentUser: (): string => {
            let clientRequestUrl = '/api/v3/signatures/me/body-details';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        searchBanners: (): string => {
            let clientRequestUrl = '/api/v3/signatures/banners/do-search';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAllSections: (): string => {
            let clientRequestUrl = '/api/v3/signatures/sections';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getTemplateById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v3/signatures/templates/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAllLogos: (): string => {
            let clientRequestUrl = '/api/v3/signatures/logos';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves the signature for the logged-in user.
     * @return OK
     */
    async getSignature(): Promise<Signature> {
        const clientRequestUrl = this.baseUrl + this.routes.getSignature();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<Signature>(_response, false, []);
    }

    /**
     * Saves a signature for the website www.sgmarkets.com.
     * @param body (optional) The signature to be saved.
     * @return No Content
     */
    async saveSignature(
        body?: Signature,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.saveSignature();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Retrieves the signature content for the current user.
     * @return OK
     */
    async getSignatureBodyForCurrentUser(): Promise<SignatureBodyResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSignatureBodyForCurrentUser();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SignatureBodyResponse>(_response, false, []);
    }

    /**
     * Search banners by various criteria
     * @param body (optional) 
     * @return OK
     */
    async searchBanners(
        body?: SearchBannersRequest,
    ): Promise<SearchBannersResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.searchBanners();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SearchBannersResponse>(_response, false, []);
    }

    /**
     * Get all sections
     * @return OK
     */
    async getAllSections(): Promise<GetAllSectionsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAllSections();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetAllSectionsResponse>(_response, false, ['endDate']);
    }

    /**
     * Get a template by its id
     * @param id The unique identifier of the template.
     * @return OK
     */
    async getTemplateById(
        id: number,
    ): Promise<Template> {
        const clientRequestUrl = this.baseUrl + this.routes.getTemplateById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<Template>(_response, false, ['endDate']);
    }

    /**
     * Get all logos
     * @return OK
     */
    async getAllLogos(): Promise<GetAllLogosResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAllLogos();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetAllLogosResponse>(_response, false, []);
    }
}
